/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_createUKInstitutionRequest } from '../models/api_createUKInstitutionRequest';
import type { api_createUKInstitutionResponse } from '../models/api_createUKInstitutionResponse';
import type { db_GetUKInstitutionRow } from '../models/db_GetUKInstitutionRow';
import type { db_GetUserContactsByUKInstitutionIDRow } from '../models/db_GetUserContactsByUKInstitutionIDRow';
import type { db_ListUKInstitutionsRow } from '../models/db_ListUKInstitutionsRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UkInstitutions {
    /**
     * Get a list of UK institutions
     * @param pageId Page ID
     * @param pageSize Page size
     * @param orderBy Order by
     * @param filters Filters
     * @param filterModes Filter modes
     * @param search Search string
     * @returns db_ListUKInstitutionsRow OK
     * @throws ApiError
     */
    public static listUkInstitutions(
        pageId: number,
        pageSize: number,
        orderBy?: string,
        filters?: string,
        filterModes?: string,
        search?: string,
    ): CancelablePromise<Array<db_ListUKInstitutionsRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/uk-institutions',
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'order_by': orderBy,
                'filters': filters,
                'filter_modes': filterModes,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create a UK institution
     * @param body UK institution details
     * @returns api_createUKInstitutionResponse Created
     * @throws ApiError
     */
    public static createUkInstitution(
        body: api_createUKInstitutionRequest,
    ): CancelablePromise<api_createUKInstitutionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/uk-institutions',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get a UK institution record
     * @param id UK institution ID
     * @returns db_GetUKInstitutionRow OK
     * @throws ApiError
     */
    public static getUkInstitution(
        id: number,
    ): CancelablePromise<db_GetUKInstitutionRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/uk-institutions/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete a UK institution
     * @param id UKInstitution ID
     * @returns void
     * @throws ApiError
     */
    public static deleteUkInstitution(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/uk-institutions/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update a UK institution
     * @param id UKInstitution ID
     * @param body UKInstitution details
     * @returns void
     * @throws ApiError
     */
    public static updateUkInstitution(
        id: number,
        body: api_createUKInstitutionRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/uk-institutions/{id}',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get contacts linked to a UK institution
     * @param id UK institution ID
     * @returns db_GetUserContactsByUKInstitutionIDRow OK
     * @throws ApiError
     */
    public static getUkInstitutionContacts(
        id: number,
    ): CancelablePromise<Array<db_GetUserContactsByUKInstitutionIDRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/uk-institutions/{id}/contacts',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
}
